export class ForgotPassword {
    email:string
}


export class IChangePassword {
    key: string;
    password: string;
    confirm_password: string;
}